import React, { useEffect, FC } from "react";
import { Modal, ModalBody, Form, Row, Alert } from "reactstrap";
import { Icon, Button, RSelect } from "../../../components/Component";
import { FormProvider, useForm } from "react-hook-form";
import { Col } from "reactstrap";
import FormInput from "../../form-components/InputComponent";
import FormTextArea from "../../form-components/TextAreaComponent";
const EditModal: FC<any> = ({
  modal,
  closeModal,
  onSubmit,
  formData,
  setFormData,
  filterStatus,
  alertInfo,
}) => {
  useEffect(() => {
    reset(formData);
  }, [formData]);
  const methods = useForm({
    mode: "onChange",
  });

  const {
    handleSubmit,
    formState: { errors },
    reset,
  } = methods;
  return (
    <Modal
      isOpen={modal}
      toggle={() => closeModal()}
      className="modal-dialog-centered"
      size="lg"
      backdrop="static"
    >
      <ModalBody>
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            closeModal();
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>
        <div className="p-2">
          <h5 className="title">Update Department</h5>
          {alertInfo.message && (
            <div className="mb-3 mt-1">
              <Alert
                color={alertInfo.type === "error" ? "danger" : "success"}
                className="alert-icon"
              >
                <strong>{alertInfo.message}</strong>
                <Icon
                  name={
                    alertInfo.type === "error" ? "alert-circle" : "check-circle"
                  }
                />
                {alertInfo.errors.length > 0 ? (
                  <ul>
                    {alertInfo.errors.map((err: any, index: any) => (
                      <li key={index}>{err}</li>
                    ))}
                  </ul>
                ) : (
                  ""
                )}
              </Alert>
            </div>
          )}
          <div className="mt-4">
            <FormProvider {...methods}>
              <Form className="row gy-4" onSubmit={handleSubmit(onSubmit)}>
                <Col md="4">
                  <div className="form-group">
                    <FormInput
                      name="referenceID"
                      label="Department ID"
                      type="text"
                      pattern={/^[a-zA-Z0-9./_-]+$/}
                      placeholder="Enter name"
                    />
                  </div>
                </Col>
                <Col md="4">
                  <div className="form-group">
                    <FormInput
                      label="Department Name"
                      name="deptName"
                      type="text"
                      placeholder="Enter Dept Name"
                    />
                  </div>
                </Col>
                <Col md="4">
                  <div className="form-group">
                    <FormInput
                      label="Team Count"
                      name="teamCount"
                      type="number"
                      placeholder="Team Count"
                    />
                  </div>
                </Col>
                <Col md="12">
                  <div className="form-group">
                    <FormTextArea
                      name="description"
                      label="Description"
                      placeholder="Enter Description"
                      required={true}
                      maxLength={50}
                    />
                  </div>
                </Col>
                <Row className="mt-4">
                  <Col
                    size="12"
                    sm={undefined}
                    lg={undefined}
                    md={undefined}
                    xxl={undefined}
                    className={undefined}
                  >
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button
                          className="btn btn-primary btn-md"
                          type="submit"
                          color="primary"
                        >
                          <span>Update</span>
                        </Button>
                      </li>
                      <li>
                        <a
                          href="#cancel"
                          onClick={(ev) => {
                            ev.preventDefault();
                            closeModal();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </a>
                      </li>
                    </ul>
                  </Col>
                </Row>
              </Form>
            </FormProvider>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
export default EditModal;
